<template>
	<v-app>
		<v-overlay v-if="!showApp">
			Загрузка приложения
			<v-progress-circular
				:size="70"
				:width="7"
				color="purple"
				indeterminate
			/>
		</v-overlay>
		<template v-else-if="authenticated">
			<core-app-bar />

			<core-drawer />

			<core-view />

			<!--			<core-footer />-->
		</template>

		<template v-else>
			<core-view />
		</template>
	</v-app>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import axios from 'axios';

const STORE_AUTH = createNamespacedHelpers('auth');

export default {
	components: {
		CoreDrawer: () => import('@/components/core/Drawer'),
		CoreAppBar: () => import('@/components/core/AppBar'),
		CoreView: () => import('@/components/core/View'),
	},
	data() {
		return {
			showApp: false,
		};
	},
	computed: {
		...STORE_AUTH.mapGetters([ 'authenticated' ]),
		...STORE_AUTH.mapState([ 'checkingToken' ]),
	},
	created() {
		this.initRefreshToken()
			.then(() => {
				this.fetchUser();
			})
			.catch(() => {
				this.$router.push('/login');
			});
	},
	mounted() {
		const initApp = () => {
			if (this.checkingToken) {
				setTimeout(initApp, 100);
			} else {
				this.showApp = true;
			}
		};
		initApp();
		this.$http.interceptors.response.use(response => response, error => {
			if (error?.response?.status === 422) {
				return Promise.reject(error);
			}
			// игнорируем отмены запросов axios
			if (!axios.isCancel(error)) {
				this.$notify.error('Ошибка');
			}
			return Promise.reject(error);
		});
	},
	methods: {
		...STORE_AUTH.mapActions([ 'initRefreshToken', 'fetchUser' ]),
	},
}
</script>

<style lang="scss">
.container {
	max-width: none !important;
}
</style>
